import { useEffect, useState } from 'react';
import WellnessVsCargaChart from './WellnessVsCargaChart';
import API_BASE_URL from '../../../config/api';

const INTERPRETACION = {
  alerta: {
    bg: '#fcebeb', color: '#a32d2d', icon: '⚠', titulo: 'Divergen',
    texto: 'El TSB se mantiene estable, pero el wellness empeora cada semana. El cuerpo ya lo está sintiendo antes de que el modelo lo confirme — ventana para ajustar el microciclo.',
  },
  vigilar: {
    bg: '#faeeda', color: '#854f0b', icon: '◐', titulo: 'Vigilar',
    texto: 'Divergencia leve entre el modelo y la sensación del atleta. Conviene observar la próxima semana antes de ajustar el plan.',
  },
  ok: {
    bg: '#eaf3de', color: '#3b6d11', icon: '✓', titulo: 'Coinciden',
    texto: 'Las dos líneas se mueven juntas. El plan está bien calibrado para este atleta — no requiere ajuste.',
  },
  sin_datos: {
    bg: '#f1f5f9', color: '#64748b', icon: '–', titulo: 'Sin datos suficientes',
    texto: 'Aún no hay suficientes sesiones con Wellness PRE y POST registrados para este atleta en el periodo.',
  },
};

const dayKey = (d) => new Date(d).toISOString().slice(0, 10);

const WellnessVsCargaCard = ({ athleteId, athleteName, rangeDays = 28 }) => {
  const [data, setData] = useState([]);
  const [estado, setEstado] = useState('ok');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!athleteId) return;
    let cancelado = false;
    setLoading(true);
    setError(null);

    const end = new Date();
    const start = new Date();
    start.setDate(start.getDate() - rangeDays);
    const fromISO = start.toISOString();
    const toISO = end.toISOString();

    const wellnessUrl = API_BASE_URL + '/api/wellness-vs-carga/' + athleteId + '?from=' + fromISO + '&to=' + toISO;
    const pmcUrl = API_BASE_URL + '/api/performance/pmc/' + athleteId + '?start=' + fromISO + '&end=' + toISO;

    Promise.all([
      fetch(wellnessUrl).then((r) => (r.ok ? r.json() : [])),
      fetch(pmcUrl).then((r) => (r.ok ? r.json() : [])),
    ])
      .then(([wellnessRows, pmcRows]) => {
        if (cancelado) return;

        const tsbByDate = {};
        (pmcRows || []).forEach((p) => { tsbByDate[dayKey(p.date)] = p.tsb; });

        const merged = (wellnessRows || []).map((w) => ({ ...w, tsb: tsbByDate[w.date] ?? null }));
        setData(merged);

        const deltas = merged.map((r) => r.delta).filter((d) => d != null);
        if (deltas.length < 2) { setEstado('sin_datos'); return; }
        const inicio = (deltas[0] + (deltas[1] ?? deltas[0])) / 2;
        const fin = (deltas[deltas.length - 1] + (deltas[deltas.length - 2] ?? deltas[deltas.length - 1])) / 2;
        const divergencia = inicio - fin;
        setEstado(divergencia > 3 ? 'alerta' : divergencia > 1 ? 'vigilar' : 'ok');
      })
      .catch((err) => { if (!cancelado) setError(err.message); })
      .finally(() => { if (!cancelado) setLoading(false); });

    return () => { cancelado = true; };
  }, [athleteId, rangeDays]);

  const info = INTERPRETACION[estado];

  return (
    <div className="td-card" style={{ padding: '10px 12px', marginTop: '8px' }}>
      <div style={{ fontSize: 11, fontWeight: 700, color: '#193255', marginBottom: 2 }}>
        🧬 Wellness vs Carga — {athleteName}
      </div>
      <div style={{ fontSize: 9, color: '#94a3b8', marginBottom: 6 }}>
        TSB del modelo (azul) y delta de wellness por sesión (naranja/rojo) — últimas {Math.round(rangeDays / 7)} semanas
      </div>

      {loading ? (
        <div style={{ fontSize: 11, color: '#94a3b8', padding: '20px 0', textAlign: 'center' }}>Cargando…</div>
      ) : error ? (
        <div style={{ fontSize: 11, color: '#a32d2d', padding: '20px 0', textAlign: 'center' }}>No se pudo cargar Wellness vs Carga.</div>
      ) : (
        <>
          <WellnessVsCargaChart data={data} estado={estado} />
          <div style={{ marginTop: 8, padding: '7px 9px', borderRadius: 7, fontSize: 10, lineHeight: 1.4, background: info.bg, color: info.color }}>
            <strong>{info.icon} {info.titulo}:</strong> {info.texto}
          </div>
        </>
      )}
    </div>
  );
};

export default WellnessVsCargaCard;
